import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'

import { allStateOptions } from '../../common/stateOptions'
import { InputField, SelectField } from '../../../components/inputs'
import LoaderButton from '../../../components/loaderButton'
import { ReduxFormProps } from '../../../forms'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  cancel: Callback
  title: string
}

export interface FormProps {
  line1: string
  city: string
  state: string
  zip: string
}

export class UserAddressForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  static displayName = 'UserAddressForm'

  render() {
    const { cancel, handleSubmit, submitting, title } = this.props

    return (
      <form
        className="form create-address__form"
        name="UserAddressForm"
        onSubmit={handleSubmit}
      >
        <h2 className="form__header create-address__form--title">{title}</h2>

        <div
          className="create-address__form--content"
          // disabled={submitting} // TODO-TS
        >
          <Field
            className="create-address__form--input"
            type="text"
            label="Address"
            name="line1"
            data-testid="create-address-form-address-input"
            component={InputField}
          />

          <Field
            className="create-address__form--input"
            type="text"
            label="Address line 2"
            name="line2"
            data-testid="create-address-form-address-line2-input"
            component={InputField}
          />

          <Field
            className="create-address__form--input"
            type="text"
            label="City"
            name="city"
            data-testid="create-address-form-city-input"
            component={InputField}
          />

          <Field
            className="create-address__form--input"
            label="State"
            name="state"
            defaultOption="No state selected"
            data-testid="create-address-form-state-input"
            component={SelectField}
          >
            {allStateOptions}
          </Field>

          <Field
            className="create-address__form--input"
            type="text"
            label="Zip Code"
            name="zip"
            data-testid="create-address-form-zip-input"
            component={InputField}
          />
        </div>
        <div className="form__button-group create-address__form--buttons">
          <LoaderButton
            type="submit"
            className="button button--primary-round"
            data-testid="create-address-form-submit"
            isLoading={submitting}
          >
            Submit
          </LoaderButton>
          <a
            onClick={cancel}
            data-testid="create-address-form-cancel"
            className="button button--secondary-round"
          >
            Cancel
          </a>
        </div>
      </form>
    )
  }
}

export const validate = (data) => {
  const { line1, city, state, zip } = data
  const errors: Partial<FormProps> = {}

  if (!line1) {
    errors.line1 = 'Address required'
  }

  if (!city) {
    errors.city = 'City required'
  }

  if (!state) {
    errors.state = 'State required'
  }

  if (!zip) {
    errors.zip = 'Zip code required'
  }

  return errors
}

export default reduxForm<FormProps, Props>({
  form: 'userAddressForm',
  validate,
  enableReinitialize: false,
  destroyOnUnmount: true,
})(UserAddressForm)
